import $ from "jquery";
import "jquery-mask-plugin";
import { Klass, u_ } from "@pressmedia/webappbase";

// extend mask plugin
if( u_.isFunction($.fn.mask) && !$.fn.mask.isCustomized ) {
	$.fn._mask_original_ = $.fn.mask;
	$.fn.mask = function() {
		const event = $.fn.mask.isSafariPC ? "change" : "input";
		this.off("maskCustom").on(`${event}.maskCustom`, function() {
			// 全角英数を半角に置換
			this.value = this.value.replace(/[Ａ-Ｚａ-ｚ０-９]/g, s => {
				return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
			});
		});
		
		if($.fn.mask.isSafariPC) {
			// pc版SafariはIMEの影響で不具合が生じる
			return this;
		}
		
		return $.fn._mask_original_.apply(this, arguments);
	};
	
	$.fn.mask.isSafariPC =
		Klass("Console").browser[0] === "safari" && Klass("Console").device[0] === "pc";
	$.fn.mask.isCustomized = true;
}
